import { HOT_RELOADING_DISABLED_KEY } from "@faire/web--source/common/consts/HOT_RELOADING_DISABLED_KEY";
import { getLocationOrThrow } from "@faire/web--source/common/globals/getLocation";
import { Storage } from "@faire/web--source/common/Storage";
import debug from "debug";

const log = debug("IF:HOT-RELOADING");

export const setupHotLoading = (port: string) => {
  try {
    if (
      process.env.NODE_ENV === "development" &&
      Storage.local.getItem(HOT_RELOADING_DISABLED_KEY) !== "true"
    ) {
      const url = `ws://localhost:${port}`;
      const connection = new WebSocket(url);
      connection.onopen = () => {
        log("Reloading websocket is connected, watching changes...");
      };
      connection.onerror = (error) => {
        log(error);
      };
      connection.onmessage = (e) => {
        if (e.data === "RELOAD") {
          log("Change has been detected, reloading...");
          getLocationOrThrow().reload();
        }
      };
    }
  } catch (_) {
    // silence is golden
  }
};
